import { TandemEvent, ValidTandemEvent } from "@/lib/drivers/tandem/commands/Event";
import { BasalRateChangeEvent, LID_BASAL_RATE_CHANGE } from "@/lib/drivers/tandem/events/LID_BASAL_RATE_CHANGE";
import { TandemData } from "@/lib/drivers/tandem/TandemTypes";
import { TandemTransformer } from "@/lib/drivers/tandem/transformers/TandemTransformer";
import { BasalRateChangeDTO } from "@/models/InsulinModel";

export class TandemBasalRateEventTransformer implements TandemTransformer<BasalRateChangeDTO[]> {
  _is_basal_rate_change_event = (event: TandemEvent<unknown>): event is ValidTandemEvent<BasalRateChangeEvent> =>
    event.id === LID_BASAL_RATE_CHANGE.value && event.valid;

  get_basal_rate_events = (pumpEvents: ValidTandemEvent<BasalRateChangeEvent>[]): BasalRateChangeDTO[] => {
    const result: BasalRateChangeDTO[] = [];
    for (const event of pumpEvents) {
      result.push({
        sequence_id: event.eventSequenceNum,
        date: event.timestamp.toISO() ?? "",
        basal_rate: event.payload.commandedBasalRate,
        base_basal_rate: event.payload.baseBasalRate,
        temp_rate: event.payload.changeTypes.includes("temp_rate_start"),
        temp_rate_percent: event.payload.ratePercent,
      });
    }
    return result;
  };

  transform = (data: TandemData): BasalRateChangeDTO[] => {
    const events = data.events.events.filter(e => this._is_basal_rate_change_event(e));

    return this.get_basal_rate_events(events);
  };
}
